<bn-loading-overlay></bn-loading-overlay>
<div class="container"  *ngIf="model">
    <form [formGroup]="formNota" class="form">

        <div class="row">
            <div class="col">
                <h3>Nota de Operacao de Garantia <small *ngIf="model.id" class="text-muted">(#ID: {{model.id}})</small></h3>
            </div>            
            <div class="col-auto">
                <button type="button" class="btn " 
                  [ngClass]="formNota.pristine ? 'btn-primary' : 'btn-danger' " 
                  (click)="voltarParaLista ()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
                </button>
                  
                <button *ngIf="modoEdicao" type="button" class="btn btn-primary" 
                  [disabled]="formNota.pristine || !formNota.valid" 
                  (click)="salvar ()">Salvar
                </button>
      
                <button *ngIf="permissaoEdicao && !modoEdicao && exibeBotaoParaUsuarioLogado()" type="button" class="btn btn-primary" 
                    (click)="habilitarEdicao ()">Editar
                </button>            
            </div>

        </div>

        <div class="row ">
            <div class="col-md-9 bn-form-group">
                <label class="form-label"><b>Agente Financeiro:</b></label>
                <select class="form-select" name="idAgenteFinanceiro" formControlName="idAgenteFinanceiro" >
                    <option [ngValue]=agente.id *ngFor="let agente of agentesFinanceiros">
                        {{ agente.nome }}
                    </option>
                </select>
            </div> 
            <div class="col-md-3 bn-form-group">
                <label class="form-label"><b>Estado:</b></label>
                <select class="form-select" name="estado" formControlName="estado">
                    <option *ngFor="let estado of estados" 
                        [ngValue]="estado.valor">{{ estado.descricao }}
                    </option>
                </select>  
            </div>
        </div>   
            
        <div class="row" >
            <div class="col-md-3 bn-form-group">
                <label class="form-label">Tipo Operação/Sistema:</label>
                <select class="form-select" name="classeOperacao" ngDefaultControl formControlName="classeOperacao">
                    <option *ngFor="let classeOperacao of classesOperacao" 
                        [ngValue]="classeOperacao.codigo">{{ classeOperacao.nome }}
                    </option>
                </select>  
            </div>
            <div class="col-md-5 bn-form-group">
                <label class="form-label">Id externo operação:</label>
                    <input class="form-control" name="idOperacaoExterno" ngDefaultControl formControlName="idOperacaoExterno">
            </div>
    
            <div class="col-md-4 bn-form-group">
                <label class="form-label">Contrato:</label>
                <input class="form-control" name="contratoRepasse" ngDefaultControl formControlName="contratoRepasse">
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-12 bn-form-group">
                <label class="form-label" for="anexo"><b>Anexo</b></label>
                <div class="input-group">
                    <div *ngIf="modoEdicao">
                        <input type="file" class="form-control" id="anexo" name="anexo" [disabled]="!modoEdicao" readonly 
                            (change)="inputLabel.innerText = preparaUpload($event.target)" />
                    </div>
                    
                    <input *ngIf="!modoEdicao" type="text" class="form-control" name="nomeAnexo" formControlName="nomeAnexo"/>
                    <div *ngIf="model.id && model.nomeAnexo && !modoEdicao">
                        <span class="input-group-text d-block" (click)="exportarAnexo()"><i class="fa fa-download cursor-pointer" ngbTooltip="Exportar Anexo"></i></span>
                    </div>
                </div>
            </div> 
        </div>

        <div class="row">
            <div class="col-md-12 bn-form-group">
                <label class="form-label"><b>Mensagem</b></label>
                <textarea class="form-control" formControlName="mensagem" rows="3"></textarea>
            </div>
        </div>
        <div class="row">    
            <div class="col-md-2">
                <label class="form-label"><b>Data de envio</b></label>
                <input type="text" class="form-control" name="dataEnvio" formControlName="dataEnvio">
            </div>            
            <div class="col-md-6">
                <label class="form-label"><b>Enviado por</b></label>
                <input type="text" class="form-control" name="nomeUsuarioEnvio" formControlName="nomeUsuarioEnvio">
            </div>
        </div>
    </form>
    
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>    
</div>